import { Clock } from 'lucide-react';

export default function ComingSoonPage() {
  return (
    <div
      data-testid="coming-soon-page"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 18,
        textAlign: 'center',
        padding: '48px 24px',
      }}
    >
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          background: 'var(--bg-secondary, #f1f5f9)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--text-muted, #64748b)',
        }}
      >
        <Clock size={32} strokeWidth={1.5} />
      </div>
      <p
        style={{
          fontSize: 16,
          color: 'var(--text-muted, #64748b)',
          margin: 0,
          maxWidth: 480,
        }}
      >
        Este módulo estará disponible próximamente.
      </p>
    </div>
  );
}
